<template>
  <div class="points-log-page">
    <van-nav-bar 
      title="积分明细" 
      left-text="返回" 
      left-arrow 
      @click-left="$router.back()"
      fixed 
      :placeholder="true" 
    />
    
    <div class="log-content">
      <!-- 筛选标签页 -->
      <div class="filter-tabs">
        <div 
          :class="['tab-item', activeTab === 'all' ? 'active' : '']"
          @click="onTabChange('all')"
        >
          全部
        </div>
        <div 
          :class="['tab-item', activeTab === 'out' ? 'active' : '']"
          @click="onTabChange('out')"
        >
          支出
        </div>
        <div 
          :class="['tab-item', activeTab === 'in' ? 'active' : '']"
          @click="onTabChange('in')"
        >
          收入
        </div>
      </div>

      <!-- 明细列表 -->
      <div class="log-list">
        <div v-if="filteredLogs.length === 0" class="empty-state">
          <div class="empty-icon">📊</div>
          <div class="empty-text">暂无积分明细</div>
        </div>
        
        <div v-else class="log-items">
          <div class="log-item" v-for="item in filteredLogs" :key="item.id">
            <div class="log-main">
              <div class="log-info">
                <div class="log-title">{{ item.desc }}</div>
                <div class="log-time">{{ item.createdAt }}</div>
              </div>
              <div class="log-amount">
                <span :class="['amount-text', item.isAdd ? 'positive' : 'negative']">
                  {{ item.isAdd ? '+' : '' }}{{ item.points.toFixed(2) }}
                </span>
                <div v-if="item.totalPoints !== undefined" class="balance-text">
                  余额：{{ item.totalPoints.toFixed(2) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 加载更多 -->
      <div v-if="hasMore" class="load-more">
        <van-loading v-if="loading" type="spinner" color="#667eea" />
        <span v-else class="load-text" @click="loadMore">加载更多</span>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/api-service'
export default {
  name: 'PointsLog',
  data() {
    return {
      activeTab: 'all',
      logs: [],
      total: 0,
      pageNo: 1,
      pageSize: 10,
      loading: false,
      hasMore: true
    }
  },
  computed: {
    filteredLogs() {
      if (this.activeTab === 'out') {
        return this.logs.filter(item => item.points < 0);
      }
      if (this.activeTab === 'in') {
        return this.logs.filter(item => item.points > 0);
      }
      return this.logs;
    }
  },
  created() {
    this.fetchLogs();
  },
  methods: {
    onTabChange(name) {
      this.activeTab = name;
      this.pageNo = 1;
      this.logs = [];
      this.hasMore = true;
      this.fetchLogs();
    },
    fetchLogs() {
      if (this.loading) return;
      
      this.loading = true;
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize
      };
      
      Api.getPointsLogs(params).then(res => {
        const newLogs = (res.list || []).map(item => ({
          ...item,
          isAdd: item.isAdd,
          points: Number(item.points),
          totalPoints: Number(item.totalPoints)
        }));
        
        if (this.pageNo === 1) {
          this.logs = newLogs;
        } else {
          this.logs = [...this.logs, ...newLogs];
        }
        
        this.total = res.total || 0;
        this.hasMore = this.logs.length < this.total;
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    loadMore() {
      if (this.hasMore && !this.loading) {
        this.pageNo++;
        this.fetchLogs();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.points-log-page {
  background-color: #f7f7fa;
  min-height: 100vh;

  .log-content {
    padding: 16px;

    .filter-tabs {
      display: flex;
      background: white;
      border-radius: 16px;
      margin-bottom: 16px;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
      overflow: hidden;

      .tab-item {
        flex: 1;
        text-align: center;
        font-size: 15px;
        color: #7f8c8d;
        padding: 16px 0;
        font-weight: 500;
        transition: all 0.3s ease;
        cursor: pointer;
        
        &.active {
          color: #667eea;
          background: rgba(102, 126, 234, 0.05);
          position: relative;
          
          &:after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            width: 20px;
            height: 3px;
            background: #667eea;
            border-radius: 2px;
          }
        }

        &:active {
          background: rgba(102, 126, 234, 0.1);
        }
      }
    }

    .log-list {
      .empty-state {
        background: white;
        border-radius: 16px;
        padding: 60px 20px;
        text-align: center;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);

        .empty-icon {
          font-size: 48px;
          margin-bottom: 16px;
          opacity: 0.6;
        }

        .empty-text {
          font-size: 14px;
          color: #7f8c8d;
          font-weight: 500;
        }
      }

      .log-items {
        .log-item {
          background: white;
          border-radius: 16px;
          margin-bottom: 12px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
          overflow: hidden;

          .log-main {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 16px 20px;

            .log-info {
              flex: 1;
              padding-right: 16px;

              .log-title {
                font-size: 15px;
                color: #2c3e50;
                font-weight: 600;
                margin-bottom: 6px;
                line-height: 1.4;
              }

              .log-time {
                font-size: 12px;
                color: #7f8c8d;
                font-weight: 400;
              }
            }

            .log-amount {
              text-align: right;
              flex-shrink: 0;

              .amount-text {
                font-size: 16px;
                font-weight: 700;
                display: block;
                margin-bottom: 4px;
                letter-spacing: 0.3px;

                &.positive {
                  color: #52c41a;
                }

                &.negative {
                  color: #ff4d4f;
                }
              }

              .balance-text {
                font-size: 11px;
                color: #7f8c8d;
                font-weight: 400;
              }
            }
          }
        }
      }
    }

    .load-more {
      background: white;
      border-radius: 16px;
      padding: 20px;
      margin-top: 16px;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
      text-align: center;

      .load-text {
        color: #667eea;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.3s ease;

        &:active {
          opacity: 0.7;
        }
      }
    }
  }
}
</style> 